module.exports = __webpack_public_path__ + "img/october-yellow.5f641945.svg";